package kz.dentalcrm.app.screens.protocols.list.mvi

import kotlinx.collections.immutable.PersistentList
import kz.dentalcrm.app.core.base.ViewSideEffect
import kz.dentalcrm.app.data.network.response_model.services.ServiceItem
import kz.dentalcrm.app.data.network.response_model.services_category.ServiceCategory

sealed interface ProtocolsViewSideEffect : ViewSideEffect {

    data class ShowEditService(val service: ServiceItem) :
        ProtocolsViewSideEffect

    data class ShowCategories(
        val serviceCategory: PersistentList<ServiceCategory>
    ) : ProtocolsViewSideEffect

}